import axios, { InternalAxiosRequestConfig } from 'axios';
import { CARTEIRA_URL } from 'domain/infra/data/env';
import { carteiraTokenManager } from './carteiraTokenManager';

let isRegistered = false;

export function registerCarteiraAuthInterceptor(): void {
    if (isRegistered) {
        return;
    }

    axios.interceptors.request.use(async function carteiraTokenInterceptor(config: InternalAxiosRequestConfig) {
        const url = config.url || '';

        if (url.startsWith(CARTEIRA_URL) && !url.includes('/oauth2/token')) {
            const token = await carteiraTokenManager.GetCarteiraToken();
            if (token) {
                config.headers.Authorization = token;
            }
        }

        return config;
    });

    isRegistered = true;
}
